import React from 'react'

import {
    AppTypeHeaderDiv,
    AppTypeDiv
} from  '../../Styles/Components/AppTypeHeaderStyles'

function AppListHeader(props){
    return (
        <AppTypeHeaderDiv>
            <AppTypeDiv>Application Types</AppTypeDiv>
        </AppTypeHeaderDiv>
    )
}

export default AppListHeader